// L'enveloppe d'un appel : celle du serveur, y compris son refus en 409, ou
// une enveloppe vide pour une panne (502, réseau), qui ne porte aucun refus
// métier. Même règle que l'écran « Accès et droits ».
export async function enveloppeDe(appel) {
  try {
    return (await appel()) || {};
  } catch (erreur) {
    return erreur?.response?.status === 409 ? erreur.response.data || {} : {};
  }
}
